module.exports = __webpack_public_path__ + "static/media/image_active_black.ce8697ce.svg";